/**
 * Menu Arrow
 * Styled arrow used on menus to signify open status
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

import { Arrow, Bubble } from './MenuArrow.style';

export default function MenuArrow({
  notifications = 0,
  selected = false,
}: {
  notifications?: number;
  selected?: boolean;
}) {
  return (
    <Bubble
      data-testid="menuarrow-bubble"
      emphasized={!selected && notifications > 0}
    >
      {notifications > 0 && (
        <p data-testid="menuarrow-notifications">{notifications}</p>
      )}
      <Arrow>
        <Icon
          color={notifications > 0 ? 'secondary.main' : 'text.primary'}
          name="chevron-down"
          rotation={-90}
        />
      </Arrow>
    </Bubble>
  );
}
